import { USERS_ACTIONS } from 'constants/Actions/Users';

// Estado inicial del reducer
const aInitialState = {
    aUsers: [],
    nTotalPages: null,
    oUser: null,

    bIsSuccess: false,
    bIsError: false,
}
/**
 * Reducer que será utilizado para controlar los datos referidos a los usuarios almacenados en el sistema.
 * 
 * @param {Array} aState Estado, si no recibe datos se setea el estado inicial
 * @param {object} oAction Action que es ejecutada
 * 
 * @returns {Array} Retorna un array que sera seteado en el estado del reducer
 * 
 * @author Leandro Curbelo 
 */
export const UserReducer = (aState = aInitialState, oAction) => {
    switch (oAction.type) {
        case USERS_ACTIONS.GET:
            return { ...aState, aUsers: oAction.data.data, nTotalPages: oAction.data.pages };
        case USERS_ACTIONS.FIND:
            return { ...aState, oUser: oAction.data };
        case USERS_ACTIONS.SUCCESS:
            return { ...aState, bIsSuccess: true };
        case USERS_ACTIONS.ERROR:
            return { ...aState, bIsError: true };
        case USERS_ACTIONS.CLEAN:
            return { ...aState, bIsSuccess: false, bIsError: false, oUser: null, };
        default:
            return aState;
    }
}